import { useEffect, useState } from "react";

const SiteUrl = "https://vipin.hyperofficial.in/";
const WebsiteAPIurl = SiteUrl + "api/";

const RendomTokenData = () => {
  const [rendomToken, setrendomToken] = useState(null);
  useEffect(() => {
    const FetchRendomToken = async () => {
      try {
        const response = await fetch(
          `${WebsiteAPIurl}rendomTokenfetch`,
          {
            method: "POST",
          }
        );
        const data = await response.json();
      //  alert("TOKEN RESPONSE =", data);
        setrendomToken(data.token);
      } catch (err) {
       // alert("FETCH ERROR =", err);
      }
    };
    FetchRendomToken();
  }, []);
  return rendomToken;
};

export default RendomTokenData;